import { render, staticRenderFns } from "./Callback.vue?vue&type=template&id=53f06d74&scoped=true"
import script from "./Callback.vue?vue&type=script&lang=ts"
export * from "./Callback.vue?vue&type=script&lang=ts"
import style0 from "./Callback.vue?vue&type=style&index=0&id=53f06d74&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f06d74",
  null
  
)

export default component.exports